
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { AuthProvider } from "@/providers/AuthProvider";
import { AppRoutes } from "./AppRoutes";
import { Analytics } from '@vercel/analytics/react';
import { useSentryUser } from "./hooks/useSentryUser";

// Create a Sentry instrumented Router
const SentryRoutes = Sentry.withSentryReactRouterV6Routing(BrowserRouter);

const queryClient = new QueryClient();

// Create a SentryUserProvider component to handle Sentry user tracking
const SentryUserProvider = ({ children }: { children: React.ReactNode }) => {
  useSentryUser();
  return <>{children}</>;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <SentryUserProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <SentryRoutes>
            <AppRoutes />
          </SentryRoutes>
          <Analytics />
        </TooltipProvider>
      </SentryUserProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
